export const getStatusStyles = (status: string) => {
  switch (status.toLowerCase()) {
    case "pending":
    case "sent":
      return "bg-blue-500/15 text-blue-700 hover:bg-blue-500/15";
    case "in Progress":
      return "bg-yellow-500/15 text-yellow-700 hover:bg-yellow-500/15";
    case "invalid":
      return "bg-red-500/15 text-red-700 hover:bg-red-500/15";
    case "completed":
      return "bg-green-500/15 text-green-700 hover:bg-green-500/15";
    default:
      return "bg-gray-500/15 text-gray-700 hover:bg-gray-500/15";
  }
};
